// StepUploadFiles.tsx
import React from "react";
import DragAndDrop from "./DragAndDrop.tsx";
import {ALLOWED_TYPES} from "../../models/constants/constants.ts";
import {formatRemainingMinutes} from "../../utils/utils.ts";

interface StepUploadFilesProps {
  uploadedFiles: File[];
  customConfigurationId?: string;
  setUploadedFiles: (files: File[]) => void;
  fileNameToSeriesNameRelation: Record<string, string>;
  setFileNameToSeriesNameRelation: (relation: Record<string, string>) => void;
  setCustomConfiguration: (configId: string | undefined) => void;
  remainingMinutes?: number;
  projectTotalDuration: number;
  setVideoDurationInMinutes: (duration: number) => void;
  handleErrors: (error: string, action?: "add" | "remove") => void;
}

const StepUploadFiles: React.FC<StepUploadFilesProps> = (
  {
    uploadedFiles,
    customConfigurationId,
    setUploadedFiles,
    fileNameToSeriesNameRelation,
    setFileNameToSeriesNameRelation,
    setCustomConfiguration,
    remainingMinutes,
    projectTotalDuration,
    setVideoDurationInMinutes,
    handleErrors,
  }:StepUploadFilesProps) => {
  return (
    <div className='flex flex-col flex-1 min-h-0'>
      <DragAndDrop
        uploadFiles={uploadedFiles}
        customConfigurationId={customConfigurationId}
        setUploadedFiles={setUploadedFiles}
        fileNameToSeriesNameRelation={fileNameToSeriesNameRelation}
        setFileNameToSeriesNameRelation={setFileNameToSeriesNameRelation}
        setCustomConfiguration={setCustomConfiguration}
        onVideoLoaded={(duration: number) => {
          setVideoDurationInMinutes(projectTotalDuration + duration);
        }}
        onVideoRemoved={(duration: number) => {
          setVideoDurationInMinutes(projectTotalDuration - duration);
        }}
        handleErrors={handleErrors}
      />
      <div className="mt-auto pt-4">
        {remainingMinutes && (
          <div className="text-sm my-0 text-loginInputsText-500 mt-2">
            * You have {formatRemainingMinutes(remainingMinutes)} left
          </div>
        )}
        {projectTotalDuration > (remainingMinutes || 0) && (
          <div className="text-sm my-0 text-red-500 mt-2">
            * You have no minutes left, please contact support to increase your limit.
          </div>
        )}
        <div className="text-sm text-gray-400 mt-2">
          * Only support {Object.values(ALLOWED_TYPES).join(", ")} files
        </div>
        <div className="text-sm text-gray-400 mt-2">
          * Upload limit: 4GB per file
        </div>
      </div>
    </div>
  );
};

export default StepUploadFiles;